import React from "react";
import { ModalHeader } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalHeader";
import { ModalBody } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalBody";
import TokenTransferStep, {
  TokenTransferStepProps,
} from "../../TokenTransferStep";
import { Body5 } from "@/src/components/typography/components/Body";
import { LinkButton } from "@/app/(main)/shop/products/[productName]/components/Button";
import { EXTERNAL_LINK_NIKE_ACCOUNT_SETTINGS } from "@/constants/app";
import { ButtonType } from "nvs-design-system/dist/Button_DEPRECATED/types";

export default function MissingPhoneNumber({
  isShowing = false,
}: TokenTransferStepProps) {
  return (
    <TokenTransferStep isShowing={isShowing}>
      <ModalHeader className="max-w-72 laptop:max-w-full">
        Missing Phone Number
      </ModalHeader>

      <ModalBody className="flex flex-col gap-6">
        <BodyCopy />
        <UpdateAccountLinkButton />
      </ModalBody>
    </TokenTransferStep>
  );
}

function BodyCopy() {
  return (
    <Body5>
      Please update your Nike account settings by adding a phone number to
      receive your verification code.
    </Body5>
  );
}

function UpdateAccountLinkButton() {
  return (
    <LinkButton
      href={EXTERNAL_LINK_NIKE_ACCOUNT_SETTINGS}
      className="rounded-md py-4 uppercase !justify-center w-full text-base font-medium"
      buttonType={ButtonType.primary}
    >
      Update Account
    </LinkButton>
  );
}
